import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    TextField, Button, Select, MenuItem, InputLabel, FormControl,
    Typography, Card, CardHeader, CardContent, Grid, Alert,
    Snackbar, CircularProgress, Container, Backdrop, Divider, Paper,
    Switch, FormControlLabel, Box, Dialog, DialogTitle, DialogContent, DialogActions,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, Tooltip
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Slide from '@mui/material/Slide';
import SendIcon from '@mui/icons-material/Send';
import PublishIcon from '@mui/icons-material/Publish';
import PreviewIcon from '@mui/icons-material/Preview';
import SaveIcon from '@mui/icons-material/Save';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import axios from 'src/utils/axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const editorModules = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image'],
        ['clean']
    ],
};

// Snackbar transition component - component dışında tanımlandı, her renderda yeniden oluşturulmaz
const SlideTransition = (props) => <Slide {...props} direction="down" />;

const formatToTRDate = (dateStr) => {
    if (!dateStr) return '../…./….';
    const [year, month, day] = dateStr.split('-');
    return `${day}.${month}.${year}`;
};

const getHeaderHtml = (title, subject, date, sayi, attachmentCount, isIptal, eskiSayi, eskiTarih) => {
    const iptalMetni = isIptal
        ? `BU BÜLTEN ${eskiSayi || '…/…./….'} SAYILI ve ${eskiTarih ? formatToTRDate(eskiTarih) : '…/…./….'} TARİHLİ BÜLTENİN YERİNE GEÇER.`
        : null;

    const count = parseInt(attachmentCount) || 0;
    const ekText = count > 0 ? String(count).padStart(2, '0') : '00';

    return `
      <h2 style="text-align: center; margin-bottom: 10px;"><strong>${title}</strong></h2>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
        <tbody>
          <tr>
            <td rowspan="2" style="width: 40%; border: 1px solid #000; padding: 8px; vertical-align: top;">
              <strong>KONU</strong>&nbsp;&nbsp;:<br/>
              ${subject || '…………………………...'}
            </td>
            <td style="width: 30%; border: 1px solid #000; padding: 8px;">
              <strong>SAYI</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;${sayi || 'HTK/…./…'}
            </td>
            <td style="width: 30%; border: 1px solid #000; padding: 8px;">
              <strong>SAYFA</strong>&nbsp;&nbsp;:&nbsp;&nbsp;[SAYFA_SAYISI]
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #000; padding: 8px;">
              <strong>TARİH</strong>&nbsp;&nbsp;:&nbsp;&nbsp;${formatToTRDate(date)}
            </td>
            <td style="border: 1px solid #000; padding: 8px;">
              <strong>EK</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;${ekText}
            </td>
          </tr>
          ${iptalMetni ? `
          <tr>
            <td colspan="3" style="border: 1px solid #000; padding: 12px; text-align: center;">
              <strong style="color: #c00;">${iptalMetni}</strong>
            </td>
          </tr>
          ` : ''}
        </tbody>
      </table>
      <hr style="border: none; margin-top: 15px;" />
      <p><br></p>
      <p>Değerli Yetkili Servislerimiz,</p>
      <p><br></p>
    `;
};

const getFooterHtml = () => `
  <p><br></p>
  <p>Tüm Yetkili Servis çalışanlarının bilgilendirilmesini ve gereğini önemle rica ederim.</p>
  <p><br></p>
  <p>Saygılarımla,</p>
  <p><br></p>
  <p>Kayahan BALTA<br>
  Arçelik Pazarlama A.Ş.<br>
  Müşteri Hizmetleri - Hizmet Tasarım &amp; Kontrol Direktörü</p>
`;

const CreateBulletin = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const editData = location.state?.editData;
    const draftData = location.state?.draftData;

    const isEditingDraft = !!draftData;
    const currentData = draftData || editData;

    const [productGroups, setProductGroups] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingAction, setLoadingAction] = useState(null);
    const [serverError, setServerError] = useState(null);

    const [lastBulletinCode, setLastBulletinCode] = useState('');
    const [loadingLastCode, setLoadingLastCode] = useState(false);

    const [attachmentCount, setAttachmentCount] = useState('');
    const [attachments, setAttachments] = useState([]);

    const [historyLogs, setHistoryLogs] = useState([]);
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);

    const [reviseDialogOpen, setReviseDialogOpen] = useState(false);
    const [reviseNote, setReviseNote] = useState('');

    const [newBulletinDialogOpen, setNewBulletinDialogOpen] = useState(false);

    const handleNewBulletinConfirm = () => {
        reset({
            category: '', productGroups: [], title: '', date: new Date().toISOString().split('T')[0],
            sayi: '', isIptalBulteni: false, eskiBultenSayisi: '', eskiBultenTarihi: '', content: '',
        });
        setAttachmentCount('');
        setAttachments([]);
        setHistoryLogs([]);
        setAuthFlags({ IsApprovalRequired: false, CanFirstApprove: false, CanFinalApprove: false, Durum: 0, SonRevizyonNotu: '' });
        setServerError(null);
        setLastBulletinCode('');
        setReviseNote('');
        setNewBulletinDialogOpen(false);
        navigate(location.pathname, { replace: true });
    };

    const [authFlags, setAuthFlags] = useState({
        IsApprovalRequired: false,
        CanFirstApprove: false,
        CanFinalApprove: false,
        Durum: 0,
        SonRevizyonNotu: ''
    });

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success', key: 0 });

    const { control, handleSubmit, watch, reset, setValue, getValues, formState: { errors } } = useForm({
        defaultValues: {
            category: '', productGroups: [], title: '', date: new Date().toISOString().split('T')[0],
            sayi: '', isIptalBulteni: false, eskiBultenSayisi: '', eskiBultenTarihi: '', content: '',
        }
    });

    const selectedCategoryId = watch('category');
    const watchedTitle = watch('title');
    const watchedDate = watch('date');
    const watchedSayi = watch('sayi');
    const watchedIsIptal = watch('isIptalBulteni');
    const watchedEskiSayi = watch('eskiBultenSayisi');
    const watchedEskiTarih = watch('eskiBultenTarihi');

    useEffect(() => {
        const count = parseInt(attachmentCount) || 0;
        const newAttachments = [...attachments];
        if (count > newAttachments.length) {
            for (let i = newAttachments.length; i < count; i++) newAttachments.push({ id: i, file: null, previewUrl: '' });
        } else {
            newAttachments.length = count;
        }
        setAttachments(newAttachments);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attachmentCount]);

    const handleFileChange = (index, event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const newAtt = [...attachments];
                newAtt[index].file = file;
                newAtt[index].type = file.type; // Dosyanın tipini tutuyoruz (application/pdf vb.)
                newAtt[index].name = file.name;
                newAtt[index].previewUrl = reader.result;
                setAttachments(newAtt);
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        if (selectedCategoryId) {
            setLoadingLastCode(true);
            setLastBulletinCode('');
            axios.get(`GetLatestBankaKodu?type=${selectedCategoryId}`, { responseType: 'text' })
                .then(response => setLastBulletinCode(response.data || 'Kayıt Bulunamadı'))
                .catch(() => setLastBulletinCode('Bilinmiyor (Hata)'))
                .finally(() => setLoadingLastCode(false));
        } else {
            setLastBulletinCode('');
        }
    }, [selectedCategoryId]);

    useEffect(() => {
        axios.get(`GetProductGroups`).then(r => r.data && setProductGroups(r.data)).catch(e => console.error(e));
        axios.get('GetBankaTipi').then(r => r.data && setCategories(r.data)).catch(e => console.error(e));
    }, []);

    const processContentAndAttachments = (rawContent, ekBilgisi) => {
        let pureContent = rawContent || '';
        const regexPattern = "<!-" + "- ATTACHMENTS::([\\s\\S]*?)::ATTACHMENTS -" + "->";
        const regex = new RegExp(regexPattern);
        const attMatch = pureContent.match(regex);

        if (attMatch) {
            pureContent = pureContent.replace(attMatch[0], '');
            try {
                const urls = JSON.parse(attMatch[1]);
                const loadedAtts = urls.map((url, i) => ({ id: i, file: null, previewUrl: url }));
                setAttachments(loadedAtts);
                setAttachmentCount(urls.length);
            } catch (e) { console.error("Ekler okunamadı", e); }
        } else {
            const parsedEk = parseInt((ekBilgisi || '').replace(/\D/g, ''), 10);
            if (!isNaN(parsedEk) && parsedEk > 0) setAttachmentCount(parsedEk);
        }
        setValue('content', pureContent);
    };

    useEffect(() => {
        const identifier = currentData?.ID;

        if (identifier && categories.length > 0 && productGroups.length > 0) {
            setLoading(true);
            const fetchUrl = isEditingDraft ? `GetDraftBulletinDetail?id=${identifier}` : `GetBulletinDetail?id=${identifier}`;

            axios.get(fetchUrl)
                .then(response => {
                    const detail = response.data;
                    if (detail) {
                        setValue('category', detail.BULTEN_KATEGORI || detail.CategoryId || '');
                        setValue('title', detail.BULTEN_KONUSU || detail.Title || '');
                        setValue('sayi', (detail.SAYI || detail.Sayi || '').replace(/_REV\w+$/i, ''));

                        const tarihStr = detail.BULTEN_TARIHI || detail.Tarih;
                        if (tarihStr) setValue('date', tarihStr.split('T')[0]);

                        setValue('isIptalBulteni', detail.IS_IPTAL || detail.IsIptal || false);
                        if (detail.IS_IPTAL || detail.IsIptal) {
                            setValue('eskiBultenSayisi', detail.ESKI_BULTEN_SAYISI || detail.EskiBultenSayisi || '');
                            const eskiTarihStr = detail.ESKI_BULTEN_TARIHI || detail.EskiBultenTarihi;
                            if (eskiTarihStr) setValue('eskiBultenTarihi', eskiTarihStr.split('T')[0]);
                        }

                        const urunlerStr = detail.URUN_GRUPLARI || detail.ProductGroupIds || '';
                        if (urunlerStr) {
                            const stringIds = String(urunlerStr).split(',');
                            const matchedProducts = productGroups.filter(p => stringIds.includes(String(p.Id)));
                            setValue('productGroups', matchedProducts);
                        }

                        processContentAndAttachments(detail.HTML_ICERIK || detail.HtmlContent, detail.EK || detail.EkBilgisi);

                        if (!isEditingDraft) {
                            // C#'tan gelen veriler camelCase (küçük harf) olabileceği için || ile her ikisini de kontrol ediyoruz
                            const canPublish = detail.CanPublish !== undefined ? detail.CanPublish : (detail.canPublish || false);

                            setAuthFlags({
                                IsApprovalRequired: !canPublish,
                                CanFirstApprove: detail.CanFirstApprove || detail.canFirstApprove || false,
                                CanFinalApprove: detail.CanFinalApprove || detail.canFinalApprove || false,
                                Durum: detail.DURUM || detail.durum || 0,
                                SonRevizyonNotu: detail.SonRevizyonNotu || detail.sonRevizyonNotu || ''
                            });

                            axios.get(`GetBulletinHistory?id=${identifier}`)
                                .then(historyRes => { if (historyRes.data) setHistoryLogs(historyRes.data); })
                                .catch(err => console.error("Tarihçe çekilemedi", err));
                        }
                    }
                })
                .catch(error => {
                    if (isEditingDraft && currentData) {
                        setValue('category', currentData.BULTEN_KATEGORI || '');
                        setValue('title', currentData.BULTEN_KONUSU || '');
                        setValue('sayi', (currentData.SAYI || '').replace(/_REV\w+$/i, ''));
                        processContentAndAttachments(currentData.HTML_ICERIK, currentData.EK);
                    }
                })
                .finally(() => setLoading(false));
        }
    }, [currentData, isEditingDraft, categories, productGroups, setValue]);

    const selectedCatObj = categories.find(c => c.Id === selectedCategoryId);
    const dynamicTitle = selectedCatObj ? selectedCatObj.Dsc.toUpperCase() : 'MÜŞTERİ HİZMETLERİ BÜLTENİ';

    // Yeni Kayıt için Anlık Kategori Onay Kontrolü
    const currentCatApprovalRequired = selectedCatObj
        ? (selectedCatObj.IsApprovalRequired === 1 || selectedCatObj.IsApprovalRequired === true)
        : true;

    // Finalde bültenin Onay gerektirip gerektirmediği (Düzeltme Modu vs Yeni Kayıt)
    const isAppReq = isEditingDraft || !currentData ? currentCatApprovalRequired : authFlags.IsApprovalRequired;

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const getAttachmentsHtml = () => {
        const count = parseInt(attachmentCount) || 0;
        if (count === 0 || attachments.length === 0) return '';

        // Tüm ekler başlamadan hemen önce tek bir sayfa kesici div ekliyoruz
        let html = '<div style="page-break-before: always;"></div>';

        attachments.forEach((att, index) => {
            if (att.previewUrl) {
                html += `
            <div class="pdf-attachment-section" style="padding-top: 30px; margin-bottom: 20px;">
                    <h3 style="text-align: left; font-family: Arial, sans-serif; border-bottom: 2px solid #ccc; padding-bottom: 5px;">EK-${index + 1}</h3>
                    <div style="text-align: center; margin-top: 10px;">
                    <img src="${att.previewUrl}" style="max-width: 100%; max-height: 900px; object-fit: contain; margin: 0 auto; display: block;" />
                </div>
            </div>
 `;
            }
        });
        return html;
    };

    const getFinalContentWithAttachments = (contentHtml) => {
        const attachmentUrls = attachments.map(a => a.previewUrl || '');
        const hasAttachments = attachmentUrls.some(url => url !== '');
        if (hasAttachments) {
            const hiddenStart = "<!-" + "- ATTACHMENTS::";
            const hiddenEnd = "::ATTACHMENTS -" + "->";
            return `${contentHtml || ''}${hiddenStart}${JSON.stringify(attachmentUrls)}${hiddenEnd}`;
        }
        return contentHtml || '';
    };

    const handlePreviewPDF = async () => {
        const data = getValues();
        const previewCatObj = categories.find(c => c.Id === data.category);
        const previewDynamicTitle = previewCatObj ? previewCatObj.Dsc.toUpperCase() : 'MÜŞTERİ HİZMETLERİ BÜLTENİ';



        // 2. C#'ın okuyabileceği saf HTML şablonunu gerçek sayfa sayısıyla oluştur
        const rawHtmlForBackend = `
<div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
    ${getHeaderHtml(previewDynamicTitle, data.title, data.date, data.sayi, attachmentCount, data.isIptalBulteni, data.eskiBultenSayisi, data.eskiBultenTarihi)}
    ${data.content}
    ${getFooterHtml()}
</div>`;

        // 3. Ekleri formatla
        const formattedAttachments = attachments
            .filter(a => a.previewUrl)
            .map((a, index) => {
                let mType = a.type;

                // Veritabanından geldiyse type boştur, data: URL içinden çıkarıyoruz.
                if (!mType && a.previewUrl.startsWith('data:')) {
                    mType = a.previewUrl.substring(5, a.previewUrl.indexOf(';'));
                }

                return {
                    FileName: a.name || `Ek_Dosya_${index + 1}`,
                    MimeType: mType || '',
                    Base64Data: a.previewUrl.includes(',') ? a.previewUrl.split(',')[1] : a.previewUrl
                };
            });

        const payload = {
            RawHtmlForPdf: rawHtmlForBackend,
            AttachmentsList: formattedAttachments,
            IsPdfGenerationRequired: true
        };

        setLoading(true); setLoadingAction('PREVIEW');

        try {
            // 3. responseType: 'blob' KALDIRILDI! Gelen veriyi string olarak alıyoruz.
            const response = await axios.post('PreviewBulletinPdf', payload);

            let base64Pdf = response.data;

            // Backend hata döndüyse (Hata: ... şeklinde) yakala
            if (typeof base64Pdf === 'string' && base64Pdf.startsWith("Hata:")) {
                setSnackbar({ open: true, message: base64Pdf, severity: 'error', key: Date.now() });
                return;
            }

            // 4. .NET Core'un eklediği baştaki ve sondaki çift tırnakları temizle
            if (typeof base64Pdf === 'string' && base64Pdf.startsWith('"')) {
                base64Pdf = base64Pdf.replace(/^"|"$/g, '');
            }

            // 5. Temizlenmiş Base64 string'i PDF dosyasına (Blob) dönüştür
            const byteCharacters = atob(base64Pdf);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // 6. Tarayıcıda aç
            const fileURL = window.URL.createObjectURL(blob);
            window.open(fileURL, '_blank');

        } catch (error) {
            console.error("Önizleme Hatası:", error);
            setSnackbar({ open: true, message: 'Önizleme oluşturulurken bir hata meydana geldi.', severity: 'error', key: Date.now() });
        } finally {
            setLoading(false); setLoadingAction(null);
        }
    };

    const handleSaveDraft = async () => {
        const data = getValues();
        if (!data.title && !data.content) {
            setSnackbar({ open: true, message: 'Taslak kaydetmek için en azından Konu veya İçerik girmelisiniz.', severity: 'warning', key: Date.now() });
            return;
        }

        setLoading(true); setLoadingAction('DRAFT'); setServerError(null);
        const count = parseInt(attachmentCount) || 0;
        const ekText = count > 0 ? `${count} Adet` : '';
        const productGroupsString = data.productGroups ? data.productGroups.map(p => p.Id).join(',') : '';
        const formatliSayi = data.sayi ? data.sayi.replace(/\//g, '_') : '';
        const formatliEskiSayi = data.eskiBultenSayisi ? data.eskiBultenSayisi.replace(/\//g, '_') : '';

        const draftPayload = {
            Id: isEditingDraft ? currentData.ID : null,
            Bankatipi: data.category || null, BankaKodu: formatliSayi || null,
            Title: data.title || null, ProductGroups: productGroupsString || null,
            GecerlilikTarihi: data.date || null, Ek: ekText,
            IsIptalBulteni: data.isIptalBulteni || false,
            EskiBultenSayisi: formatliEskiSayi || null, EskiBultenTarihi: data.eskiBultenTarihi || null,
            Content: getFinalContentWithAttachments(data.content)
        };

        try {
            const response = await axios.post('SaveDraftBulletin', draftPayload);
            const resultText = response.data;
            if (typeof resultText === 'string' && (resultText.includes('İşlem başarısız') || resultText.includes('HATA') || resultText.includes('ERROR'))) {
                setServerError(resultText); setSnackbar({ open: true, message: resultText, severity: 'error', key: Date.now() });
                return;
            }
            setSnackbar({ open: true, message: 'Taslak başarıyla kaydedildi.', severity: 'success', key: Date.now() });
            setTimeout(() => { navigate('/DraftList'); }, 1500);
        } catch (error) {
            setServerError("Taslak kaydedilirken bir hata oluştu.");
            setSnackbar({ open: true, message: 'Taslak kaydedilirken bir hata oluştu.', severity: 'error', key: Date.now() });
        } finally {
            setLoading(false); setLoadingAction(null);
        }
    };

    const handleSendRevision = async () => {
        if (!reviseNote.trim()) {
            setSnackbar({ open: true, message: 'Lütfen revizyon talebiniz için bir neden belirtin.', severity: 'warning', key: Date.now() });
            return;
        }
        setLoading(true); setLoadingAction('REVISION'); setReviseDialogOpen(false);
        try {
            await onSubmit(getValues(), 'REVISE', reviseNote);
        } catch (error) {
            setLoading(false);
        }
    };

    const onSubmit = async (data, actionType, revisionNote = '') => {
        setLoading(true); setLoadingAction(actionType); setServerError(null);

        const count = parseInt(attachmentCount) || 0;
        const isMissingAttachment = attachments.some(a => !a.previewUrl);
        if (count > 0 && isMissingAttachment) {
            setLoading(false);
            setSnackbar({ open: true, message: 'Lütfen seçtiğiniz sayıdaki tüm ek dosyalarını yükleyin.', severity: 'error', key: Date.now() });
            return;
        }

        const productGroupsString = data.productGroups ? data.productGroups.map(p => p.Id).join(',') : '';
        const formatliSayi = data.sayi ? data.sayi.replace(/\//g, '_') : '';
        const formatliEskiSayi = data.eskiBultenSayisi ? data.eskiBultenSayisi.replace(/\//g, '_') : '';
        const ekText = count > 0 ? `${count} Adet` : '';

        const finalContent = getFinalContentWithAttachments(data.content);

        const rawHtmlForBackend = `
            <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
                ${getHeaderHtml(dynamicTitle, data.title, data.date, data.sayi, attachmentCount, data.isIptalBulteni, data.eskiBultenSayisi, data.eskiBultenTarihi)}
                ${data.content}
                ${getFooterHtml()}
            </div>`;

        const formattedAttachments = attachments
            .filter(a => a.previewUrl)
            .map((a, index) => {
                let mType = a.type;

                // Eğer bülten veritabanından geldiyse type boştur. String içinden çıkarıyoruz.
                if (!mType && a.previewUrl.startsWith('data:')) {
                    mType = a.previewUrl.substring(5, a.previewUrl.indexOf(';'));
                }

                return {
                    FileName: a.name || `Ek_Dosya_${index + 1}`,
                    MimeType: mType || '',
                    Base64Data: a.previewUrl.includes(',') ? a.previewUrl.split(',')[1] : a.previewUrl
                };
            });

        const payload = {
            Id: (currentData && !isEditingDraft) ? currentData.ID : null,
            DraftId: isEditingDraft ? currentData.ID : null,
            Bankatipi: data.category || null, BankaKodu: formatliSayi || null,
            Title: data.title || null, ProductGroups: productGroupsString || null,
            ActionType: actionType, RevisionNote: revisionNote,
            GecerlilikTarihi: data.date || null, Ek: ekText,
            IsIptalBulteni: data.isIptalBulteni || false,
            EskiBultenSayisi: formatliEskiSayi || null, EskiBultenTarihi: data.eskiBultenTarihi || null,
            Content: finalContent, // Veritabanında editlemek için tutulan saf HTML

            // YENİ EKLENEN PARAMETRELER:
            RawHtmlForPdf: rawHtmlForBackend, // C#'ın PDF'e basacağı hazır HTML şablonu
            AttachmentsList: formattedAttachments, // C#'ın merge edeceği ek dosyalar
            IsPdfGenerationRequired: true,
            PdfDocument: null // Bunu artık boş gönderiyoruz, C# dolduracak
        };

        try {

            const response = await axios.post('CreateBulletin', payload);
            const resultText = response.data;

            if (typeof resultText === 'string' && (resultText.includes('İşlem başarısız') || resultText.includes('HATA') || resultText.includes('ERROR'))) {
                setServerError(resultText); setSnackbar({ open: true, message: resultText, severity: 'error', key: Date.now() });
                return;
            }

            let successMessage = '';
            if (actionType === 'REVISE') successMessage = 'Revizyon talebiniz ilgili kişiye iletildi.';
            else if (actionType === 'SEND_FIRST_APPROVAL') successMessage = 'Bülten ilk onaya gönderildi.';
            else if (actionType === 'SEND_FINAL_APPROVAL') successMessage = 'Bülten son onaya gönderildi.';
            else if (actionType === 'APPROVE_FINAL') successMessage = 'Bülten onaylandı ve yayına hazır hale getirildi.';
            else successMessage = 'Bülten Yayınlandı';

            setSnackbar({ open: true, message: successMessage, severity: 'success', key: Date.now() });
            setTimeout(() => { navigate('/BulletinList'); }, 1500);

        } catch (error) {
            setServerError("İşlem sırasında bir hata oluştu.");
            setSnackbar({ open: true, message: 'İşlem sırasında bir hata oluştu.', severity: 'error', key: Date.now() });
        } finally {
            setLoading(false); setLoadingAction(null);
        }
    };

    return (
        <div style={{ paddingTop: '24px', paddingBottom: '24px' }}>
            <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff', flexDirection: 'column' }} open={loading}>
                <CircularProgress color="inherit" />
                <Typography sx={{ mt: 2, fontWeight: 'bold', fontSize: '20px', color: '#FF9800' }}>
                    {loadingAction === 'PREVIEW' ? "Önizleme Hazırlanıyor..."
                        : loadingAction === 'DRAFT' ? "Taslak Kaydediliyor..."
                            : loadingAction === 'REVISION' ? "Revizyon Talebi Gönderiliyor..."
                                : loadingAction ? "İşleminiz Gerçekleştiriliyor..." : "Lütfen bekleyiniz..."}
                </Typography>
            </Backdrop>

            <Container maxWidth="xl">
                <Card>
                    <CardHeader
                        title={isEditingDraft ? "Taslağı Düzenle" : (editData ? "Bülten Güncelle / İncele" : "Yeni Bülten Oluştur")}
                        subheader="Bülten içeriğini hazırlayıp onaya gönderebilir, taslak olarak kaydedebilir veya doğrudan yayınlayabilirsiniz."
                        action={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mr: 1 }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    onClick={() => setNewBulletinDialogOpen(true)}
                                >
                                    Yeni Bülten Oluştur
                                </Button>
                                {historyLogs.length > 0 && (
                                    <Tooltip title="Tüm İşlem Geçmişini Görüntüle">
                                        <IconButton color="primary" onClick={() => setHistoryDialogOpen(true)} sx={{ backgroundColor: '#f0f4f8' }}>
                                            <HistoryIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                        }
                    />
                    <Divider />
                    <CardContent>
                        {isEditingDraft && <Alert severity="info" sx={{ mb: 3 }}>Bu bir taslaktır. Üzerinde çalıştığınız bülteni taslak olarak tekrar kaydedebilir veya işleme alabilirsiniz.</Alert>}

                        {authFlags.Durum === 3 && authFlags.SonRevizyonNotu && (
                            <Alert
                                severity="error" icon={<AssignmentReturnIcon fontSize="inherit" />}
                                sx={{ mb: 3, border: '1px solid #f44336', alignItems: 'center' }}
                                action={
                                    <Tooltip title="Tüm Geçmişi Gör">
                                        <IconButton color="inherit" size="small" onClick={() => setHistoryDialogOpen(true)}><HistoryIcon /></IconButton>
                                    </Tooltip>
                                }
                            >
                                <Typography variant="subtitle2" fontWeight="bold">DİKKAT! Bu bülten için revizyon istenmiştir.</Typography>
                                <Typography variant="body2" sx={{ mt: 0.5 }}><strong>Red Nedeni / Not: </strong> {authFlags.SonRevizyonNotu}</Typography>
                            </Alert>
                        )}

                        <Grid container spacing={3}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    lg: 6
                                }}>
                                <FormControl fullWidth size="small" error={!!errors.category}>
                                    <InputLabel>Bülten Kategorisi</InputLabel>
                                    <Controller
                                        name="category"
                                        control={control}
                                        rules={{ required: "Kategori seçimi zorunludur" }}
                                        render={({ field }) => (
                                            <Select {...field} label="Bülten Kategorisi">
                                                {categories.map((cat) => (
                                                    <MenuItem key={cat.Id} value={cat.Id} sx={{ display: 'flex', width: '100%' }}>{cat.Dsc}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.category && <Typography color="error" variant="caption">{errors.category.message}</Typography>}
                                </FormControl>
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 6,
                                    lg: 6
                                }}>
                                <Controller
                                    name="productGroups"
                                    control={control}
                                    rules={{ required: "En az bir ürün grubu seçmelisiniz" }}
                                    render={({ field: { onChange, value } }) => (
                                        <Autocomplete
                                            multiple size="small" options={productGroups} value={value || []}
                                            getOptionLabel={(option) => option.Dsc || ""}
                                            isOptionEqualToValue={(option, val) => option.Id === val.Id}
                                            onChange={(_, newValue) => onChange(newValue)}
                                            renderInput={(params) => (<TextField {...params} label="Ürün Grupları" error={!!errors.productGroups} helperText={errors.productGroups?.message} />)}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Controller
                                    name="title" control={control} rules={{ required: "Başlık/Konu zorunludur" }}
                                    render={({ field }) => (<TextField {...field} onChange={(e) => { const v = e.target.value; field.onChange(v.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')); }} size="small" fullWidth label="Bülten Konusu / Başlığı" error={!!errors.title} helperText={errors.title?.message} />)}
                                />
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    md: 3
                                }}>
                                <Controller
                                    name="date" control={control} rules={{ required: "Tarih zorunludur", validate: (value) => { if (!value) return true; const year = parseInt(value.split('-')[0], 10); if (year < 1500) return 'Tarihi kontrol ediniz!'; return true; } }}
                                    render={({ field }) => (<TextField {...field} type="date" size="small" fullWidth label="Bülten Tarihi" InputLabelProps={{ shrink: true }} error={!!errors.date} helperText={errors.date?.message} />)}
                                />
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    md: 3
                                }}>
                                <Controller
                                    name="sayi" control={control}
                                    rules={{
                                        required: "Onaya göndermek ve yayınlamak için sayı zorunludur",
                                        pattern: {
                                            value: /^[A-Za-z0-9]+_\d{4}_\d{3,}$/,
                                            message: "Lütfen geçerli formatta girin (Örn: HTK_2026_001)"
                                        }
                                    }}
                                    render={({ field }) => (
                                        <TextField {...field} onChange={(e) => field.onChange(e.target.value.toUpperCase())} size="small" fullWidth label="Sayı (Örn: HTK_2026_001)"
                                            disabled={authFlags.Durum === 1}
                                            error={!!errors.sayi}
                                            helperText={authFlags.Durum === 1 ? "Yayındaki bültende sayı değiştirilemez." : (errors.sayi?.message || (loadingLastCode ? "Son sayı kontrol ediliyor..." : lastBulletinCode ? `Kategorideki Son Sayı: ${lastBulletinCode}` : "Lütfen kategori seçiniz"))}
                                            FormHelperTextProps={{ sx: { color: authFlags.Durum === 1 ? 'text.disabled' : (errors.sayi ? 'error.main' : (lastBulletinCode && !lastBulletinCode.includes('Hata') ? 'info.main' : 'text.secondary')), fontWeight: !errors.sayi && lastBulletinCode && authFlags.Durum !== 1 ? 'bold' : 'normal' } }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <TextField
                                    type="number" size="small" fullWidth label="Bültene Eklenecek Dosya Sayısı (EK)" value={attachmentCount}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === '') setAttachmentCount('');
                                        else { const num = parseInt(val, 10); if (num >= 0) setAttachmentCount(num); }
                                    }}
                                    inputProps={{ min: 0 }}
                                />
                            </Grid>

                            {parseInt(attachmentCount) > 0 && (
                                <Grid size={12}>
                                    <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f0f4f8' }}>
                                        <Typography variant="subtitle2" color="primary" sx={{ mb: 2 }}>
                                            Lütfen eklenecek belgelerin resim formatında (JPG, PNG) olmasına dikkat ediniz. Her bir ek, PDF'te yeni bir sayfada görünecektir.
                                        </Typography>
                                        <Grid container spacing={2}>
                                            {attachments.map((att, index) => (
                                                <Grid
                                                    key={index}
                                                    size={{
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }}>
                                                    <Box sx={{ border: '1px dashed #ccc', p: 2, borderRadius: 1, textAlign: 'center', backgroundColor: '#fff' }}>
                                                        <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>EK-{index + 1}</Typography>
                                                        <Button variant="outlined" component="label" startIcon={<CloudUploadIcon />} fullWidth size="small">
                                                            Dosya Seç
                                                            {/* accept parametresine .pdf EKLENDİ */}
                                                            <input type="file" accept=".pdf, image/png, image/jpeg, image/jpg" hidden onChange={(e) => handleFileChange(index, e)} />
                                                        </Button>
                                                        {att.previewUrl && (
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography variant="caption" color="success.main" display="block">
                                                                    {att.type === 'application/pdf' ? 'PDF Yüklendi' : 'Resim Yüklendi'}
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1 }}>{att.name}</Typography>

                                                                {/* Eğer resimse göster, PDF ise bir PDF ikonu/metni göster */}
                                                                {att.type === 'application/pdf' ? (
                                                                    <PictureAsPdfIcon sx={{ fontSize: 40, color: '#d32f2f' }} />
                                                                ) : (
                                                                    <img src={att.previewUrl} alt={`Ek ${index + 1}`} style={{ marginTop: '10px', maxWidth: '100%', maxHeight: '100px', objectFit: 'contain' }} />
                                                                )}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Paper>
                                </Grid>
                            )}

                            <Grid size={12}>
                                <Controller
                                    name="isIptalBulteni" control={control}
                                    render={({ field }) => (<FormControlLabel control={<Switch checked={field.value} onChange={field.onChange} color="primary" />} label="Bu bülten, eski bir bülteni iptal edip yerine geçecek" />)}
                                />
                            </Grid>

                            {watchedIsIptal && (
                                <>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}>
                                        <Controller
                                            name="eskiBultenSayisi"
                                            control={control}
                                            rules={{
                                                required: "İptal edilen eski bültenin sayısı zorunludur",
                                                pattern: {
                                                    value: /^[A-Za-z0-9]+_\d{4}_\d+$/,
                                                    message: "Lütfen geçerli formatta girin (Örn: HTK_2026_001)"
                                                },
                                                validate: (value) => {
                                                    if (!value) return true;
                                                    const match = value.match(/^[A-Za-z0-9]+_(\d{4})_\d+$/);
                                                    if (!match) return true;
                                                    const year = parseInt(match[1], 10);
                                                    const currentYear = new Date().getFullYear();
                                                    if (year < 2000 || year > currentYear + 5) return `Yıl geçersiz görünüyor. Lütfen doğru yılı giriniz (Örn: ${currentYear})`;
                                                    return true;
                                                }
                                            }}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    onChange={(e) => field.onChange(e.target.value.toUpperCase())}
                                                    size="small"
                                                    fullWidth
                                                    label="Yerine Geçtiği Eski Bülten Sayısı"
                                                    placeholder="Örn: HTK_2025_12"
                                                    error={!!errors.eskiBultenSayisi}
                                                    helperText={errors.eskiBultenSayisi?.message}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 6
                                        }}>
                                        <Controller name="eskiBultenTarihi" control={control} rules={{ validate: (value) => { if (!value) return true; const year = parseInt(value.split('-')[0], 10); if (year < 1500) return 'Tarihi kontrol ediniz!'; return true; } }} render={({ field }) => (<TextField {...field} type="date" size="small" fullWidth label="Yerine Geçtiği Eski Bülten Tarihi" InputLabelProps={{ shrink: true }} error={!!errors.eskiBultenTarihi} helperText={errors.eskiBultenTarihi?.message} />)} />
                                    </Grid>
                                </>
                            )}

                            <Grid size={12}>
                                <Typography variant="subtitle2" color="textSecondary" gutterBottom>Bülten İçeriği</Typography>
                                <Paper variant="outlined" sx={{ p: 4, minHeight: '600px', display: 'flex', flexDirection: 'column', backgroundColor: '#fafafa' }}>
                                    <div dangerouslySetInnerHTML={{ __html: getHeaderHtml(dynamicTitle, watchedTitle, watchedDate, watchedSayi, attachmentCount, watchedIsIptal, watchedEskiSayi, watchedEskiTarih).replace('[SAYFA_SAYISI]', '..') }} />
                                    <Controller
                                        name="content" control={control} rules={{ required: "İçerik zorunludur" }}
                                        render={({ field }) => (
                                            <div style={{ flexGrow: 1, margin: '20px 0' }}>
                                                <style>{`.ql-editor { font-family: Calibri, 'Calibri', sans-serif !important; font-size: 11pt; }`}</style>
                                                <ReactQuill theme="snow" modules={editorModules} value={field.value} onChange={field.onChange} placeholder="İçeriği buraya yazınız..." style={{ minHeight: '200px', backgroundColor: '#fff', fontFamily: "Calibri, 'Calibri', sans-serif" }} />
                                            </div>
                                        )}
                                    />
                                    <div dangerouslySetInnerHTML={{ __html: getFooterHtml() }} />
                                </Paper>
                                {errors.content && <Typography color="error" variant="caption">{errors.content.message}</Typography>}
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />

                        {/* KATI STATE MACHINE - DİNAMİK BUTON YÖNETİMİ */}
                        <Grid container spacing={2}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 3
                                }}>
                                <Button variant="outlined" color="info" fullWidth disabled={loading} endIcon={<PreviewIcon />} sx={{ py: 1.5 }} onClick={handlePreviewPDF}>
                                    PDF ÖNİZLE
                                </Button>
                            </Grid>

                            {/* EĞER DURUM 2 İSE (İLK ONAY BEKLİYOR) */}
                            {authFlags.Durum === 2 ? (
                                authFlags.CanFirstApprove ? (
                                    <>
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 4
                                            }}>
                                            <Button variant="contained" color="error" fullWidth endIcon={<AssignmentReturnIcon />} sx={{ py: 1.5 }} onClick={() => setReviseDialogOpen(true)}>
                                                REVİZYON İSTE
                                            </Button>
                                        </Grid>
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 5
                                            }}>
                                            <Button variant="contained" color="secondary" fullWidth disabled={loading} endIcon={<SendIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, 'SEND_FINAL_APPROVAL'))}>
                                                SON ONAYA GÖNDER
                                            </Button>
                                        </Grid>
                                    </>
                                ) : (
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 9
                                        }}>
                                        <Alert severity="warning" sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                                            Bu bülten "İlk Onay" aşamasındadır. Yalnızca yetkili onaycı işlem yapabilir.
                                        </Alert>
                                    </Grid>
                                )
                            ) :
                                /* EĞER DURUM 5 İSE (SON ONAY BEKLİYOR) */
                                authFlags.Durum === 5 ? (
                                    authFlags.CanFinalApprove ? (
                                        <>
                                            <Grid
                                                size={{
                                                    xs: 12,
                                                    sm: 4
                                                }}>
                                                <Button variant="contained" color="error" fullWidth endIcon={<AssignmentReturnIcon />} sx={{ py: 1.5 }} onClick={() => setReviseDialogOpen(true)}>
                                                    REVİZYON İSTE
                                                </Button>
                                            </Grid>
                                            <Grid
                                                size={{
                                                    xs: 12,
                                                    sm: 5
                                                }}>
                                                <Button variant="contained" color="success" fullWidth disabled={loading} endIcon={<CheckCircleIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, 'APPROVE_FINAL'))}>
                                                    ONAYLA (YAYINA HAZIR YAP)
                                                </Button>
                                            </Grid>
                                        </>
                                    ) : (
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 9
                                            }}>
                                            <Alert severity="warning" sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                                                Bu bülten "Son Onay" aşamasındadır. Yalnızca yetkili son onaycı işlem yapabilir.
                                            </Alert>
                                        </Grid>
                                    )
                                ) :
                                    /* EĞER DURUM 6 İSE (YAYINA HAZIR) -> SADECE YAYINLA BUTONU */
                                    authFlags.Durum === 6 ? (
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 9
                                            }}>
                                            <Button variant="contained" fullWidth color="success" disabled={loading} endIcon={<PublishIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, 'PUBLISH'))}>
                                                YAYINLA
                                            </Button>
                                        </Grid>
                                    ) :
                                        /* EĞER DURUM 1 İSE (YAYINDA OLAN BİR BÜLTENİ GÜNCELLEME) */
                                        authFlags.Durum === 1 ? (
                                            <Grid
                                                size={{
                                                    xs: 12,
                                                    sm: 9
                                                }}>
                                                <Button variant="contained" fullWidth color="success" disabled={loading} endIcon={<PublishIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, isAppReq ? 'SEND_FIRST_APPROVAL' : 'PUBLISH'))}>
                                                    GÜNCELLE VE {isAppReq ? 'ONAYA GÖNDER' : 'YAYINLA'}
                                                </Button>
                                            </Grid>
                                        ) :
                                            /* DİĞER TÜM DURUMLAR (Yeni Kayıt, Taslak, Revize Bekleyen) */
                                            (
                                                <>
                                                    <Grid
                                                        size={{
                                                            xs: 12,
                                                            sm: 3
                                                        }}>
                                                        <Button variant="contained" color="warning" fullWidth disabled={loading} endIcon={<SaveIcon />} sx={{ py: 1.5, color: 'white' }} onClick={handleSaveDraft}>
                                                            TASLAK KAYDET
                                                        </Button>
                                                    </Grid>

                                                    <Grid
                                                        size={{
                                                            xs: 12,
                                                            sm: isAppReq ? 6 : 3
                                                        }}>
                                                        <Button variant="contained" color="secondary" fullWidth disabled={loading} endIcon={<SendIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, isAppReq ? 'SEND_FIRST_APPROVAL' : 'APPROVAL'))}>
                                                            ONAYA GÖNDER
                                                        </Button>
                                                    </Grid>

                                                    {!isAppReq && (
                                                        <Grid
                                                            size={{
                                                                xs: 12,
                                                                sm: 3
                                                            }}>
                                                            <Button variant="contained" fullWidth color="success" disabled={loading} endIcon={<PublishIcon />} sx={{ py: 1.5 }} onClick={handleSubmit((d) => onSubmit(d, 'PUBLISH'))}>
                                                                YAYINLA
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                </>
                                            )}
                        </Grid>
                    </CardContent>
                </Card>
            </Container>

            <Dialog open={historyDialogOpen} onClose={() => setHistoryDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #e0e0e0', pb: 2 }}>
                    <HistoryIcon color="primary" /> Bülten İşlem Geçmişi
                    <IconButton onClick={() => setHistoryDialogOpen(false)} sx={{ ml: 'auto' }}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    {historyLogs.length > 0 ? (
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>Tarih</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>İşlem Yapan</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>İşlem Tipi</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>Açıklama / Notlar</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {historyLogs.map((log, index) => {
                                        const d = new Date(log.IslemTarihi || log.islemTarihi);
                                        const dateStr = `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
                                        const islemYapan = log.IslemYapan || log.islemYapan;
                                        const islemTipi = log.IslemTipi || log.islemTipi || '';
                                        const notlar = log.Notlar || log.notlar || '-';
                                        return (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{dateStr}</TableCell>
                                                <TableCell>{islemYapan}</TableCell>
                                                <TableCell>
                                                    <Chip label={islemTipi} size="small" variant="filled" color={islemTipi.includes('Revize') ? 'error' : islemTipi.includes('Onay') || islemTipi.includes('Yayın') ? 'success' : 'default'} />
                                                </TableCell>
                                                <TableCell>{notlar}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box sx={{ p: 4, textAlign: 'center' }}><Typography variant="body1" color="textSecondary">Bu bülten için henüz bir işlem geçmişi bulunmuyor.</Typography></Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
                    <Button onClick={() => setHistoryDialogOpen(false)} variant="contained" color="inherit" sx={{ px: 4 }}>Kapat</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={newBulletinDialogOpen} onClose={() => setNewBulletinDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold' }}>Yeni Bülten Oluştur</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Bültenden çıkıyorsunuz, kaydetmediğiniz değişiklikleriniz silinecektir! Çıkmak istediğinize emin misiniz?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setNewBulletinDialogOpen(false)} color="inherit" variant="outlined">Hayır</Button>
                    <Button onClick={handleNewBulletinConfirm} color="secondary" variant="contained">Evet</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={reviseDialogOpen} onClose={() => setReviseDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold', color: '#d32f2f' }}>Revizyon Talebi Oluştur</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2 }}>Lütfen bu bültenin neden reddedildiğini detaylıca belirtin. Bu not bülten sahibine iletilecektir.</Typography>
                    <TextField autoFocus margin="dense" label="Revizyon Nedeni / Eksiklikler" type="text" fullWidth multiline rows={4} variant="outlined" value={reviseNote} onChange={(e) => setReviseNote(e.target.value)} />
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setReviseDialogOpen(false)} color="inherit" variant="text">Vazgeç</Button>
                    <Button onClick={handleSendRevision} color="error" variant="contained" disabled={loading}>Revizyon İste Gönder</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={null} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} TransitionComponent={SlideTransition}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%', boxShadow: 3 }} style={{ backgroundColor: snackbar.severity === 'error' ? '#c62828' : snackbar.severity === 'success' ? '#2e7d32' : undefined, color: '#fff' }}>{snackbar.message}</Alert>
            </Snackbar>
        </div>
    );
};

export default CreateBulletin;